module.exports = __webpack_public_path__ + "assets/bf-es.58ed2d8b.svg";